import usePageTitle from "@/hooks/usePageTitle";
import { Navigate, useLocation } from "react-router-dom";

export default function PersonIndexPage() {
  usePageTitle("/billing/orders", "Billing | Orders");
  const location = useLocation();
  return <Navigate to={`${location.pathname}/orders`} replace />;
}
